import { LoadableLazy } from '@confluence/loadable';

export const SmartButtonConfigPanel = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SmartButtonConfigPanel" */ '../src/smart-buttons/edit/SmartButtonConfigPanel/SmartButtonConfigPanel.tsx'
			)
		).SmartButtonConfigPanel,
});
